import React from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Vote, MessageSquare, Lightbulb, Mic, ExternalLink } from "lucide-react";
import PageBlocks from "@/components/site/PageBlocks";
import PageHeader from "@/components/site/PageHeader";

const ICONS = { sondage: Vote, questionnaire: Vote, vote: Vote, boite_idees: Lightbulb, temoignage: Mic };
const COLORS = { sondage: "bg-cef-blue text-white", questionnaire: "bg-cef-blue text-white", vote: "bg-cef-pink text-white", boite_idees: "bg-cef-yellow", temoignage: "bg-cef-green" };

export default function Avis() {
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    api.get("/consultations").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center gap-3 mb-2"><MessageSquare className="w-8 h-8" strokeWidth={2.5} /><span className="chip bg-cef-yellow">Plateforme de consultation</span></div>
      <PageHeader slug="avis" fallbackTitle="Donner [mon avis](blue)" fallbackSubtitle="Vote, témoigne, propose. Tes réponses sont compilées et transmises aux décideurs." />

      <PageBlocks slug="avis" className="mt-6" />

      <div className="mt-8 grid md:grid-cols-2 gap-5" data-testid="consult-grid">
        {items.map((c) => {
          const Icon = ICONS[c.type] || Vote;
          const count = (c.respondents_override !== null && c.respondents_override !== undefined) ? c.respondents_override : c.participants_count;
          const cardContent = (
            <>
              <div className={`inline-flex items-center gap-2 chip ${COLORS[c.type]}`}>
                <Icon className="w-3.5 h-3.5" /> {c.type.replace("_", " ")}
                {c.external_url && <ExternalLink className="w-3 h-3 ml-1" />}
              </div>
              <h3 className="mt-3 font-display font-black text-xl tracking-tight">{c.title}</h3>
              <p className="mt-2 text-sm text-neutral-600">{c.description}</p>
              <div className="mt-4 flex items-center justify-between text-sm">
                <span className="font-bold">{count} participant·e·s</span>
                <span className={`chip ${c.status === "en_cours" ? "bg-cef-green" : "bg-white"}`}>{c.status === "en_cours" ? "Ouvert" : "Fermé"}</span>
              </div>
            </>
          );
          if (c.external_url) {
            return (
              <a key={c.id} href={c.external_url} target="_blank" rel="noreferrer" className="neo-card p-6 block" data-testid={`consult-card-${c.slug}`}>
                {cardContent}
              </a>
            );
          }
          return (
            <Link key={c.id} to={`/donner-mon-avis/${c.slug}`} className="neo-card p-6 block" data-testid={`consult-card-${c.slug}`}>
              {cardContent}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
